export default "__VITE_ASSET__BhhiyaAf__"